<script setup lang="ts">
  import type { TypographyProps } from './types'

  withDefaults(defineProps<TypographyProps>(), {
    element: 'p',
    variant: 'text-base',
    weight: 'font-normal',
    lineHeight: '',
    classes: '',
  })
</script>

<template>
  <component :is="element" :class="[variant, weight, lineHeight, classes]">
    <slot />
  </component>
</template>
